import React, { Component } from "react";
import { Popconfirm, Upload, message } from "antd";
import Http from "../../../../networkReq/http";
import zh_CN from "antd/es/locale/zh_CN";
import { useParams } from "react-router-dom";
import Request from "../../../../networkReq/request";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import {
  baseInfo,
  educateBackground,
  workExperience,
  oneselfEvaluation,
} from "./fieldConfig";
import {
  WrapContainer,
  EditForm,
  EchoForm,
  EchoFormItem,
  RenderForm,
  RenderFormItem,
} from "./components";
import { getToken, getDictOne, getcodeValue } from "utils/storage";
import "./index.scss";

// import { Button, Select, Input, Radio, Form, Checkbox, Message, MessageBox } from 'element-react';
// import Nav from 'components/Nav'
// import { Link } from 'react-router-dom';

const getBase64 = (img, callback) => {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
};
const CodeList = getDictOne("poli_affi_code");

const beforeUpload = (file) => {
  const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
  if (!isJpgOrPng) {
    message.error("You can only upload JPG/PNG file!");
  }
  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isLt2M) {
    message.error("Image must smaller than 2MB!");
  }
  return isJpgOrPng && isLt2M;
};

const uploadProps = {
  maxCount: 1,
  listType: "picture-card",
  name: "file",
  className: "avatar-uploader",
  showUploadList: false,
  action: "/tyjrmh/api/blade-file/fileServer/uploadSingle",
  headers: {
    Authorization: "Basic c3dvcmQ6c3dvcmRfc2VjcmV0",
    "Blade-Auth": getToken(),
  },
  beforeUpload,
};

export default class ResumeManage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      resData: {},
      baseInfo: baseInfo(),
      educateBackgrounds: [],
      workExperiences: [],
      oneselfEvaluation: oneselfEvaluation(),
      workingArea: [],
      isBaseInfoEdit: true,
      loading: false,
      currentEditIndex: 0,
      currentAddIndex: 0,
      imageUrl:
        "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg",
      // imageUrl: "",
    };
  }

  componentDidMount = () => {
    this.getResumeData();
    console.log("dictdictdictdictdictdictdict", CodeList);
  };
  //请求简历数据，并分配给各个字段
  getResumeData() {
    Http.get(Request.resumeManagement(), {}, (obj) => {
      console.log("CodeList", CodeList);
      const { data, code } = obj;
      const { educationalBackgroundJson = "", workExperienceJson = "" } = data;
      let educateBackgrounds =
        educationalBackgroundJson != ""
          ? JSON.parse(educationalBackgroundJson)
          : [];
      let workExperiences =
        workExperienceJson != "" ? JSON.parse(workExperienceJson) : [];
      let baseInfoData = baseInfo(data);
      data.politicalFace =
        ["", "党员", "团员", "群众"][data.politicalFace] || data.politicalFace;
      data.gender = ["", "男", "女"][data.gender] || data.gender;
      data.highestEducation =
        ["", "高中", "大专", "本科", "研究生", "硕士", "博士"][
          data.highestEducation
        ] || data.highestEducation;
      data.politicalFace = getcodeValue("poli_affi_code", data.politicalFace);
      console.log("baseInfo(data)baseInfo(data)", baseInfo(data), data);
      if (code == 200) {
        // if (
        //   process.env.NODE_ENV === "development" &&
        //   data.resumePhoto &&
        //   data.resumePhoto.indexOf("fileservice") === -1
        // ) {
        //   data.resumePhoto = "/fileservice/" + data.resumePhoto;
        // }
        this.setState({
          resData: data,
          baseInfo: baseInfo(data),
          oneselfEvaluation: oneselfEvaluation(data),
          educateBackgrounds: educateBackgrounds.map((item) =>
            educateBackground(item)
          ),
          workExperiences: workExperiences.map((item) => workExperience(item)),
          imageUrl: data.resumePhoto ? data.resumePhoto : this.state.imageUrl,
        });
      }
    });
  }

  handleChange = (info) => {
    const { resData } = this.state;
    if (info.file.status === "uploading") {
      this.setState({ loading: true });
      return;
    }
    if (info.file.status === "done") {
      //当图片上传完成，将保存的图片url写入到resData中
      let resumePhoto = info.file.response.data.url;
      // let resumePhoto = info.file.response.data.path;
      // 解决接口返回url路径不统一（测试相对路径，生产绝对路径，且路径前缀也不统一）造成的下载简历头像不显示问题
      // if (
      //   process.env.NODE_ENV === "development" &&
      //   resumePhoto &&
      //   resumePhoto.indexOf("fileservice") === -1
      // ) {
      //   resumePhoto = "/fileservice/" + resumePhoto;
      // }
      this.setState({ resData: { ...resData, resumePhoto } });
      getBase64(info.file.originFileObj, (url) => {
        this.setState({ loading: false, imageUrl: url });
      });
    }
  };

  //深拷贝数据对象
  deepCopy = (params) => {
    return JSON.parse(JSON.stringify(params));
  };

  //响应表单输入的改变，将值写入数据对象中
  onChange(typeIndex, value, nameIndex) {
    console.log("RRRRRRRRRRRRRRRRRRRRRR", value);
    const arr = [
      "",
      "baseInfo",
      "educateBackgrounds",
      "workExperiences",
      "oneselfEvaluation",
    ];
    const [type, index] = typeIndex.split("-");
    const [name, nindex] = nameIndex.split("-");
    const currentChange = arr[type];
    const dataList = this.state[currentChange];
    //如果是1，4类型则遍历数组，找到name直接设置值，如果是2，3类型则遍历当前编辑的数组子项，找到name然后设置值
    if (type == 2 || type == 3) {
      dataList[index].forEach((ele) => {
        ele.name == name && (ele.value = value);
      });
    } else {
      dataList.forEach((ele) => {
        ele.name == name && (ele.value = value);
      });
    }
    this.setState({ [currentChange]: dataList });
  }

  //当2，3类型增加一条数据,构造一条新数据加入对应的类型数组中，并将当前编辑索引和当前新增索引设置为刚添加的这条数据
  onAddInfo(type) {
    const { educateBackgrounds, workExperiences } = this.state;
    switch (type) {
      case 2:
        educateBackgrounds.push(educateBackground());
        this.setState({ educateBackgrounds });
        this.setState({
          currentEditIndex: `2-${educateBackgrounds.length - 1}`,
          currentAddIndex: `2-${educateBackgrounds.length - 1}`,
        });
        break;
      case 3:
        workExperiences.push(workExperience());
        this.setState({ workExperiences });
        this.setState({
          currentEditIndex: `3-${workExperiences.length - 1}`,
          currentAddIndex: `3-${workExperiences.length - 1}`,
        });
        break;
      default:
        break;
    }
  }

  //当被编辑时，设置编辑索引为当前编辑的这条数据
  onEditInfo(typeIndex) {
    // const { mapData } = this.state
    const arr = [
      "",
      "baseInfo",
      "educateBackgrounds",
      "workExperiences",
      "oneselfEvaluation",
    ];
    const [type, index] = typeIndex.split("-");
    const currentEdit = arr[type];
    const currentObj = Array.isArray(this.state[currentEdit][0])
      ? this.state[currentEdit][index]
      : this.state[currentEdit];
    //深拷贝编辑对象
    this.setState({
      currentEditIndex: typeIndex,
      workingArea: this.deepCopy(currentObj),
    });
  }

  //删除相应的数据项
  onDelInfo(typeIndex) {
    const { educateBackgrounds, workExperiences } = this.state;
    const [type, index] = typeIndex.split("-");
    switch (type) {
      case "2":
        educateBackgrounds.splice(index, 1);
        this.setState({ educateBackgrounds });
        //将经过删除后的数据提取提交
        let educationalBackgroundJson = JSON.stringify(
          this.eachPickUp(educateBackgrounds)
        );
        this.submitResumeData({ educationalBackgroundJson });
        return;
      case "3":
        workExperiences.splice(index, 1);
        this.setState({ workExperiences });
        //将经过删除后的数据提取提交
        let workExperienceJson = JSON.stringify(
          this.eachPickUp(workExperiences)
        );
        this.submitResumeData({ workExperienceJson });
        return;
      default:
        break;
    }
  }
  //当点击取消时，将编辑索引设置0，并将被编辑过或者被新增过的数据还原
  handleCancel(typeIndex) {
    const { currentAddIndex } = this.state;
    const arr = [
      "",
      "baseInfo",
      "educateBackgrounds",
      "workExperiences",
      "oneselfEvaluation",
    ];
    const [type, index] = typeIndex.split("-");
    const currentEdit = arr[type];
    let originalData = this.deepCopy(this.state[currentEdit]);
    if (type == 2 || type == 3) {
      //Array.isArray(originalData[0])
      if (currentAddIndex == typeIndex) {
        //如果取消的是新增的数据项，则删除新增的数据项
        originalData.pop();
      } else {
        originalData[index] = this.state.workingArea;
      }
    } else {
      originalData = this.state.workingArea;
    }
    this.setState({ currentEditIndex: 0, [currentEdit]: originalData });
  }

  //将当前修改过的表单数据收集起来
  formatData(type) {
    const { baseInfo, educateBackgrounds, workExperiences, oneselfEvaluation } =
      this.state;
    let obj = {};
    switch (type - 0) {
      case 1:
        baseInfo.forEach((item) => {
          obj[item.name] = item.value || "";
        });
        break;
      case 4:
        oneselfEvaluation.forEach((item) => {
          obj[item.name] = item.value || "";
        });
        break;
      case 2:
        obj.educationalBackgroundJson = JSON.stringify(
          this.eachPickUp(educateBackgrounds)
        );
        break;
      case 3:
        obj.workExperienceJson = JSON.stringify(
          this.eachPickUp(workExperiences)
        );
        break;
      default:
        break;
    }
    return obj;
  }
  //遍历数组及数组的每一个子元素，将其内部的name，value全部提取出来
  eachPickUp(list) {
    let arr = [];
    list.forEach((item) => {
      let obj = {};
      item.length &&
        item.forEach((ele) => {
          if (ele.name == "startEndTimes") {
            obj[ele.name] = Array.isArray(ele.value)
              ? ele.value.join("~")
              : ele.value;
          } else {
            obj[ele.name] = ele.value || "";
          }
        });
      arr.push(obj);
    });
    return arr;
  }
  //保存时将数据提交
  handleSave(typeIndex) {
    const [type, index] = typeIndex.split("-");
    const submitData = this.formatData(type);
    if (submitData.politicalFace) {
      CodeList.map((value) => {
        if (value.dictValue == submitData.politicalFace) {
          submitData.politicalFace = value.dictKey;
        }
      });
    }
    console.log("submitData.politicalFace", submitData.politicalFace);
    // return;
    this.submitResumeData(submitData);

    console.log("submitDatasubmitDatasubmitDatasubmitData", submitData);
  }

  //数据提交请求
  submitResumeData(submitData) {
    const { resData } = this.state;
    Http.postJson(Request.addResume(), { ...resData, ...submitData }, (res) => {
      if (res.code == 200) {
        message.success("操作成功");
        this.setState({ currentEditIndex: 0, currentAddIndex: 0 });
        this.getResumeData();
      } else {
        message.error(res.msg);
      }
    });
  }

  render() {
    const {
      resData,
      baseInfo,
      educateBackgrounds,
      workExperiences,
      oneselfEvaluation,
      currentEditIndex,
      imageUrl,
      loading,
    } = this.state;
    console.log("propspropsprops", currentEditIndex);
    return (
      <div className="resume_manage">
        <div className="base_info">
          <WrapContainer
            title="基本信息"
            addEditBtn={() => (
              <div
                className="edit_info"
                onClick={() => this.onEditInfo("1-0")}
              ></div>
            )}
          >
            {currentEditIndex == "1-0" ? (
              <EditForm>
                <RenderForm
                  dataList={baseInfo}
                  onChange={this.onChange.bind(this, "1-0")}
                  handleCancel={this.handleCancel.bind(this, "1-0")}
                  handleSave={this.handleSave.bind(this, "1-0")}
                >
                  {(props) => <RenderFormItem {...props} />}
                </RenderForm>
                <div className="upload_photo">
                  <Upload {...uploadProps} onChange={this.handleChange}>
                    {imageUrl ? (
                      <img
                        src={imageUrl}
                        alt="avatar"
                        style={{ width: "100%" }}
                      />
                    ) : (
                      <div>
                        {loading ? <LoadingOutlined /> : <PlusOutlined />}
                        <div style={{ marginTop: 8 }}>上传头像</div>
                      </div>
                    )}
                  </Upload>
                </div>
              </EditForm>
            ) : (
              <EchoForm
                dataList={baseInfo}
                otherComponent={() => (
                  <div className="user_photo">
                    <img
                      src={imageUrl}
                      alt="avatar"
                      style={{ width: "100%" }}
                    />
                  </div>
                )}
              >
                {(props) => {
                  console.log("propspropspropsprops", props);
                  return <EchoFormItem {...props} />;
                }}
              </EchoForm>
            )}
          </WrapContainer>
        </div>
        <div className="educate_background">
          <WrapContainer
            title="教育背景"
            addEditBtn={(title) => (
              <div className="add_info" onClick={() => this.onAddInfo(2)}>
                新增{title}
              </div>
            )}
          >
            <div className="form_echo2 tbox">
              <span className="form_item_echo thead">毕业院校</span>
              <span className="form_item_echo thead">专业</span>
              <span className="form_item_echo thead">学历</span>
              <span className="form_item_echo thead">起止时间</span>
            </div>
            {educateBackgrounds.map((item, index) => {
              return currentEditIndex == `2-${index}` ? (
                <EditForm key={index}>
                  <RenderForm
                    dataList={item}
                    onChange={this.onChange.bind(this, `2-${index}`)}
                    handleCancel={this.handleCancel.bind(this, `2-${index}`)}
                    handleSave={this.handleSave.bind(this, `2-${index}`)}
                    formIndex={index}
                  >
                    {(props) => <RenderFormItem {...props} />}
                  </RenderForm>
                </EditForm>
              ) : (
                <EchoForm
                  key={index}
                  dataList={item}
                  typeIndex={`2-${index}`}
                  onEditInfo={this.onEditInfo.bind(this)}
                  onDelInfo={this.onDelInfo.bind(this)}
                >
                  {(props) => <EchoFormItem {...props} />}
                </EchoForm>
              );
            })}
          </WrapContainer>
        </div>
        <div className="work_experience">
          <WrapContainer
            title="工作经历"
            addEditBtn={(title) => (
              <div className="add_info" onClick={() => this.onAddInfo(3)}>
                新增{title}
              </div>
            )}
          >
            {workExperiences.map((item, index) => {
              return currentEditIndex == `3-${index}` ? (
                <EditForm key={index}>
                  <RenderForm
                    dataList={item}
                    onChange={this.onChange.bind(this, `3-${index}`)}
                    handleCancel={this.handleCancel.bind(this, `3-${index}`)}
                    handleSave={this.handleSave.bind(this, `3-${index}`)}
                    formIndex={index}
                  >
                    {(props) => <RenderFormItem {...props} />}
                  </RenderForm>
                </EditForm>
              ) : (
                <EchoForm
                  key={index}
                  dataList={item}
                  typeIndex={`3-${index}`}
                  onEditInfo={this.onEditInfo.bind(this)}
                  onDelInfo={this.onDelInfo.bind(this)}
                >
                  {(props) => <EchoFormItem {...props} />}
                </EchoForm>
              );
            })}
          </WrapContainer>
        </div>
        <div className="oneself_evaluation">
          <WrapContainer
            title="自我评价"
            addEditBtn={() => (
              <div
                className="edit_info"
                onClick={() => this.onEditInfo("4-0")}
              ></div>
            )}
          >
            {currentEditIndex == "4-0" ? (
              <EditForm>
                <RenderForm
                  dataList={oneselfEvaluation}
                  onChange={this.onChange.bind(this, "4-0")}
                  handleCancel={this.handleCancel.bind(this, "4-0")}
                  handleSave={this.handleSave.bind(this, "4-0")}
                >
                  {(props) => <RenderFormItem {...props} />}
                </RenderForm>
              </EditForm>
            ) : (
              <EchoForm
                dataList={oneselfEvaluation}
                typeIndex={"4-0"}
                onEditInfo={this.onEditInfo.bind(this)}
                onDelInfo={this.onDelInfo.bind(this)}
                showEditBtn={false}
                showDelBtn={false}
              >
                {(props) => <EchoFormItem {...props} />}
              </EchoForm>
            )}
          </WrapContainer>
        </div>
      </div>
    );
  }
}
